
<template>
  <div style="background-color: #fafafa; width: 100%">
    <div class="container">
      <div class="row h60">
        <!-- <img src="../static/css/login_img/iletisimmakinesi-logo-1.png" title="iletisim makinesi logo"> -->
        <img src="static/images/logo.png" class="img-fluid my-3" />
      </div>
      <div class="row d-flex">
        <div
          id="menu col-4"
          style="
            background-color: #fff;
            margin-right: 30px;
            border-radius: 8px;
            padding-top: 20px;
            padding-left: 27px;
            padding-bottom: 48px;
            padding-right: 27px;
            height: 430px;
          "
        >
          <div class="menu">
            <p
              class="fw600 fs23 lh24 coloBlack"
              style="border-bottom: 1px solid #e1e1e1; padding-bottom: 20px"
            >
              Sorun Giderme
            </p>
            <p class="fs16 fw600 colorBlack lh20" style="padding-top: 31px">
              <a href="#link1">Doğrulama kodunu nasıl aktif edebilirim?</a>
            </p>
            <p class="fs16 fw600 colorBlack lh20" style="padding-top: 37px">
              <a href="#link2">QR Kodunu tarayamıyor musunuz?</a>
            </p>
            <p class="fs16 fw600 colorBlack lh20" style="padding-top: 37px">
              <a href="#link3">Doğrulama kodu çalışmıyor</a>
            </p>
            <p class="fs16 fw600 colorBlack lh20" style="padding-top: 37px">
              <a href="#link4">Doğrulama kodumu nasıl sıfırlarım?</a>
            </p>
            <p class="fs16 fw600 colorBlack lh20" style="padding-top: 37px">
              <a href="#link5">Kurtarma koduna erişimim yok</a>
            </p>
          </div>
        </div>
        <div
          class="col-8"
          id="context"
          style="
            background-color: #fff;
            border-radius: 8px;
            padding: 45px 24px 58px 24px;
          "
        >
          <p class="fs28 fw600 colorBlack" id="link1">
            Doğrulama kodunu nasıl aktif edebilirim?
          </p>
          <p class="fs16 lh24 pt10">
            İki aşamalı doğrulama kodunu kullanabilmeniz için telefonunuza
            “Google Authenticator” uygulamasını kurmanız ve aktif etmeniz
            gerekmektedir.
          </p>
          <p class="fw600 fs19 lh20 colorBlack pt52">
            1. Google Authenticator uygulamasını telefonunuza kurun
          </p>
          <p class="fs16 lh24 pt10">
            Telefonunuzun işletim sistemine göre (<b>App Store</b> ya da
            <b>Google Play</b> ) “Google Authenticator” uygulamasını indirin ve
            telefonunuza kurulumunu yapın.
          </p>
          <div class="pt28">
            <img
              class="pr18"
              src="static/images/im-appstore-logo.png"
              title="appstore logo"
            />
            <img
              src="static/images/im-googleplaystore-logo.png"
              title="appstore logo"
            />
          </div>

          <div class="pt52">
            <p class="fw600 fs19 lh20">2. İndirdiğiniz uygulamayı açın</p>
            <p class="fs16 lh24 pt10">
              Uygulamayı açtıktan sonra karşınıza ilk kurulum ekranı çıkacaktır.
              Burada “<b>QR kodunu tara</b>” seçeneğini seçerek devam ediyoruz.
              İşleme devam ettiğimizde uygulama içerisinde kameranız açılacak ve
              QR kodu taramaya hazır hale gelecektir.
            </p>
            <div class="pt28">
              <img class="pr18" src="static/images/Device-frame2.png" />
              <img src="static/images/Device-frame.png" />
            </div>
          </div>
          <div class="pt52">
            <p class="fw600 fs19 lh20">3. QR Kodu tarayın</p>
            <p class="fs16 lh24 pt10">
              Telefonunuzu bilgisayarınızdaki tarayıcada açık halde duran QR
              koda doğru yaklaştırarak kodu tarayabilirsiniz. Kodu taradığınızda
              “<b>Google Authenticator</b>” uygulamasına yeni bir satır
              eklenecek ve 6 haneli doğrulama kodunu görebileceksiniz.
            </p>
            <div class="pt28">
              <img
                class="pr18"
                src="static/images/iyspanel-ikiasamali-image-02.png"
              />
            </div>
          </div>
          <div class="pt52">
            <p class="fw600 fs19 lh20">
              4. Doğrulama kodunu ilgili alana yazın
            </p>
            <p class="fs16 lh24 pt10">
              Google Authenticator 30 saniye boyunca kullanabileceğiniz bir kod
              üretir ve bu kod her 30 saniyeden sonra değişir. Uygulamanın
              ürettiği kodu 30 saniye içinde bilgisayarınızdaki tarayıcıda açık
              halde duran ekranda ilgili alana yazınız ve “<b
                >Doğrulama Kodunu Aktif Et</b
              >” butonuna basınız.
            </p>
            <div class="pt28">
              <img
                class="pr18"
                src="static/images/iyspanel-ikiasamali-image-03.png"
              />
            </div>
          </div>
          <div class="pt52">
            <p class="fw600 fs19 lh20">
              5. İki aşamalı doğrulama kodunuz aktif edildi
            </p>
            <p class="fs16 lh24 pt10">
              Doğrulama kodunuzun aktif edildiğine dair bir mesaj alırsınız. Bu
              mesajı “<b>Tamam</b>” butonuna basarak onaylayabilirsiniz.
              Onayınızın ardından MinimumCRM kontrol paneline
              yönlendirileceksiniz.
            </p>
          </div>

          <div class="pt100" id="link2">
            <p class="fs28 fw600 colorBlack">Barkodu tarayamıyor musunuz?</p>
            <p class="fs16 lh24 pt10">
              Google Authenticator uygulaması ile QR kodunu tarayamıyorsanız,
              Kurtarma kodunu kullanarak İki Aşamalı Doğrulama Kodunu aktif
              edebilirsiniz. Kurtarma kodu ile aktif edebilmeniz için;
            </p>
          </div>
          <div class="pt28">
            <p class="fw600 fs19 lh20">
              1.Kurtarma kodunu girerek doğrulama anahtarını kurun
            </p>
            <p class="fs16 lh24 pt10">
              Google Authenticator uygulamasını açın. Daha önce herhangi bir
              doğrulama kodunu aktif etmediyseniz “<b>Kurulum anahtarı gir</b>”
              seçeneğini dokunun. Daha önceden kullanmış olduğunuz bir kod varsa
              yeni bir kod eklemek için ( + ) tuşuna basın ve “<b
                >Kurulum anahtarı gir</b
              >” seçeneğini seçin.
            </p>
            <div class="pt28">
              <img
                class="pr18"
                src="static/images/im-ikiasamali-image-04.png"
              />
            </div>
          </div>
          <div class="pt52">
            <p class="fw600 fs19 lh20">2. Gerekli bilgileri girin</p>
            <p class="fs16 lh24 pt10">
              Hesap adınızı belirlemek için “<b>Hesap adı</b>” kısmını doldurun.
              (Örn. MinimumCRM yazın) “<b>Anahtarınız</b>” kısmına
              bilgisayar ekranında görünen “<b>Kurtarma Kodu</b>” kısmında yer
              alan 16 haneli kodu yazın. Anahtar türü “<b>Zaman bazlı</b>”
              olarak bırakın ve ardından “<b>Ekle</b>” tuşuna basın. Sonrasında
              uygulama içinde doğrulama kodunu görebilirsiniz.
            </p>
            <div class="pt28">
              <img
                class="pr18"
                src="static/images/im-ikiasamali-image-05.png"
              />
            </div>
          </div>
          <div class="pt52">
            <p class="fw600 fs19 lh20">
              3. Doğrulama kodunu ilgili alana yazın
            </p>
            <p class="fs16 lh24 pt10">
              Google Authenticator 30 saniye boyunca kullanabileceğiniz bir kod
              üretir ve bu kod her 30 saniyeden sonra değişir. Uygulamanın
              ürettiği kodu 30 saniye içinde bilgisayarınızdaki tarayıcıda açık
              halde duran ekranda ilgili alana yazınız ve “<b
                >Doğrulama Kodunu Aktif Et</b
              >” butonuna basınız.
            </p>
            <div class="pt28">
              <img
                class="pr18"
                src="static/images/im-ikiasamali-image-06.png"
              />
            </div>
          </div>
          <div class="pt52">
            <p class="fw600 fs19 lh20">
              4. İki aşamalı doğrulama kodunuz aktif edildi
            </p>
            <p class="fs16 lh24 pt10">
              Doğrulama kodunuzun aktif edildiğine dair bir mesaj alırsınız. Bu
              mesajı “Tamam” butonuna basarak onaylayabilirsiniz. Onayınızın
              ardından MinimumCRM kontrol paneline yönlendirileceksiniz.
            </p>
          </div>

          <div class="pt100" id="link3">
            <p class="fs28 fw600 colorBlack">Doğrulama kodu çalışmıyor</p>
            <p class="fs16 lh24 pt10">
              Google Authenticator’un ürettiği doğrulama kodları ile MinimumCRM' e giriş yapamıyorsanız uygulama içinde ve telefonunuzda
              bazı ayarlamalar yapmanız gerekebilir.
            </p>
          </div>
          <div class="pt28">
            <p class="fw600 fs19 lh20">
              Uygulamanın zaman ayarlarını senkronize edin
            </p>
            <p class="fs16 lh24 pt10">
              Eğer MinimumCRM 2 aşamalı doğrulama kodu çalışmaz ise,
              “Google Authetnticator” uygulamasının ayar sayfasında yer alan
              senkronizasyonu çalıştırın.
            </p>
            <div class="pt28">
              <img
                class="pr18"
                src="static/images/im-ikiasamali-image-07.png"
              />
            </div>
          </div>
          <div class="pt52">
            <p class="fw600 fs19 lh20">
              Telefonunuzun zaman ayarlarını kontrol edin
            </p>
            <p class="fs16 lh24 pt10">
              Google Authenticator uygulamasının zaman ayarlarını senkronize
              etmenize rağmen doğrulama kodu çalışmıyor ise telefonunuzun saat
              ayarlarını kontrol edebilirsiniz. Telefonunuzun marka ve modeline
              göre saat ayarları farklı bir menü içinde olabileceği için bu
              ayarlara bularak kontrol ediniz.
            </p>
          </div>
          <div class="pt28">
            <p class="fw600 fs19 lh20">Doğrulama Kodunu Sıfırlayın</p>
            <p class="fs16 lh24 pt10">
              Tüm ayarları yapmanıza rağmen hala MinimumCRM 2 aşamalı
              doğrulama kodu çalışmıyor ise Doğrulama Kodunu
              sıfırılayabilirsiniz. Doğrulama kodunu sıfırlama adımları için
              tıklayın.
            </p>
          </div>

          <div class="pt100" id="link4">
            <p class="fs28 fw600 colorBlack">
              Doğrulama kodunu nasıl sıfırlarım?
            </p>
            <p class="fs16 lh24 pt10">
              Google Authenticator uygulamasını telefonunuza yeniden
              kurduğunuzda, iki aşamalı doğrulama kodunu sildiğinizde ya da
              uygulamanın ürettiği doğrulama kodları ile MinimumCRM'e
              giriş yapamadığınızda, 2 aşamalı doğrulama kodunu yeniden aktif
              etmeniz gerekecektir.
            </p>
          </div>
          <div class="pt28">
            <p class="fw600 fs19 lh20">
              Kurtarma kodu ile doğrulama kodunu sıfırlama
            </p>
            <p class="fs16 lh24 pt10">
              MinimumCRM’de 2 aşamalı doğrulamayı etkinleştirdiğinizde
              size “<b>Kurtarma Kodu</b>” sunulmuş ve bu kodun güvenliğini
              sağlamanız istenmiştir. Eğer bu koda sahipseniz doğrulama kodunuzu
              kendiniz kolaylıkla sıfırlayabilirsiniz.
            </p>
          </div>
          <div class="pt52">
            <p class="fw600 fs19 lh20">
              1.Google Authenticator uygulamasını açın
            </p>
            <p class="fs16 lh24 pt10">
              Google Authenticator uygulamasını yeni kurduysanız ilk hesap
              oluşturma ekranında “<b>Kurulum anahtarı gir</b>” seçeneğini
              seçin. Yeni bir doğrulama kodu eklemek isterseniz ise uygulamada
              sağ alt köşede yer alan ( + ) tuşuna basın ve “<b
                >Kurulum anahtarı gir</b
              >” seçeneğini seçin.
            </p>
            <div class="pt28">
              <img
                class="pr18"
                src="static/images/im-ikiasamali-image-08.png"
              />
            </div>
          </div>
          <div class="pt52">
            <p class="fw600 fs19 lh20">2. Kurtarma Kodunu girin</p>
            <p class="fs16 lh24 pt10">
              Kurulum anahtarı gir seçeneğini seçtikten sonra hesap adınızı
              belirlemek için “<b>Hesap adı</b>” kısmını doldurun. (Örn.
              MinimumCRM yeni kod yazın) “<b>Anahtarınız</b>” kısmına
              bilgisayar ekranında görünen “<b>Kurtarma Kodu</b>” kısmında yer
              alan 16 haneli kodu yazın. Anahtar türü “<b>Zaman bazlı</b>”
              olarak bırakın ve ardından “<b>Ekle</b>” tuşuna basın. Böylece
              yeni doğrulama kodunu aktif etmiş olacaksınız.
            </p>
            <div class="pt28">
              <img
                class="pr18"
                src="static/images/im-ikiasamali-image-09.png"
              />
            </div>
          </div>
          <div class="pt52" id="link5">
            <p class="fw600 fs19 lh20">
              Kurtarma Kodu’na erişiminizin olmaması
            </p>
            <p class="fs16 lh24 pt10">
              Kurtarma Koduna erişiminiz yoksa MinimumCRM'e giriş
              yapabilmek için yeni bir “<b>Kurtarma Kodu</b>” almanız
              gerekecektir. Bunun için destek ekibimiz ile iletişime
              geçebilirsiniz. Hesap güvenliğiniz için sizden bazı doğrulama
              bilgileri istenebilir. Kimliğiniz doğrulandığında daha önce
              kullanmış olduğunuz 2 aşamalı doğrulama kodunuz sıfırlanacaktır.
              Sonrasında MinimumCRM’e ilk giriş yaptığınızda yeni QR
              kodu ve Kurtarma kodunu kullanarak 2 aşamalı doğrulama kodunuzun
              aktif edebileceksiniz.
            </p>
          </div>
          <div class="pt-4 py-4 supportDiv">
            <p class="supportDivHeader mb-1">MinimumCRM Destek Hattı</p>
            <p class="supportDivTel pt-2 mb-1">0850 483 0 444</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import Footer from "./footer.vue";

import Swal from "sweetalert2";
export default {
  name: "loginTwoFactorHelp",
  data() {
    return {};
  },
  computed: {
    ...mapState(["baseUrl", "windowWidth", "maxMobilSize", "maxTabletSize"]),
    ...mapGetters(["company_settings"]),
  },
  components: {
    Footer,
  },
  methods: {
    ...mapActions(["updateLoading", "getCompanySettings", "setUserName"]),
  },
  created() {},
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fw600 {
  font-weight: 600;
}
.fs16 {
  font-size: 16px;
}
.fs19 {
  font-size: 19px;
}
.fs28 {
  font-size: 28px;
}
.pt28 {
  padding-top: 28px;
  padding-bottom: 28px;
}
.linkStyle {
  color: #09101d;
}
.colorBlack {
  color: #000000;
  font-size: 16px;
}
.pr40 {
  padding-right: 40px;
}
.pt100 {
  padding-top: 100px;
}
.pt40 {
  padding-top: 40px;
}
.colMenu {
  max-width: 348px;
  height: 370px;
  padding-left: 27px;
  padding-top: 45px;
}
.colText {
  padding-top: 50px;
  padding-left: 24px;
}
.supportDiv {
  background-color: #0b63ce;
  border-radius: 8px;
  margin-top: 20px;
  margin-bottom: 24px;
}
.supportDivHeader {
  color: #ffffff;
  font-weight: 600;
  font-size: 24px;
  line-height: 20px;
  text-align: center;
}
.supportDivTel {
  color: #fdcc4a;
  font-weight: 600;
  font-size: 24px;
  line-height: 20px;
  text-align: center;
}
</style>
